
const govBodyToWebsiteMapping = {
	IE_EPA: 'COM',
	IE_OPW: 'COM'
};

const govBodyToMetaCountryName = {
	IE_EPA: 'Ireland',
	IE_OPW: 'Ireland',
	EA: 'United Kingdom',
	NRW: 'United Kingdom',
	SEPA: 'United Kingdom',
	'EA+SEPA': 'United Kingdom',
	'EA+NRW': 'United Kingdom',
}

const TLDHelper = {
	mapGoverningBodyToPrimaryWebsite: function(governingBody) {
		return govBodyToWebsiteMapping[governingBody] ? govBodyToWebsiteMapping[governingBody] : 'UK';
	},
	mapGoverningBodyToMetaCountryName: function(governingBody) {	
		return govBodyToMetaCountryName[governingBody] ? govBodyToMetaCountryName[governingBody] : null;
	}
};

export default TLDHelper;